import { useCallback, useMemo, useState } from 'react';
export const useConversationSearch = items => {
  const [searchTerm, setSearchTerm] = useState('');
  const onSearchChange = useCallback(e => setSearchTerm(e.target.value), []);
  const filteredItems = useMemo(() => {
    const trimmed = searchTerm.trim().toLowerCase();
    if (!trimmed) return items;
    return items.filter(item => {
      var _item$title;
      return ((_item$title = item.title) !== null && _item$title !== void 0 ? _item$title : '').toLowerCase().includes(trimmed);
    });
  }, [items, searchTerm]);
  const hasSearchTerm = searchTerm.trim().length > 0;
  const isEmptyResult = hasSearchTerm && filteredItems.length === 0;
  return {
    searchTerm,
    onSearchChange,
    filteredItems,
    hasSearchTerm,
    isEmptyResult
  };
};